import { css } from 'styled-components';

const commonHeadingStyles = css`
	margin: 0;
	line-height: 1;
	font-weight: normal;
`;

export default commonHeadingStyles;
